import * as React from "react";
const SvgFiRrXRay = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-x-ray_svg__a)">
      <path
        fill="#062147"
        d="M23 22h-1V2h1a1 1 0 1 0 0-2H1a1 1 0 1 0 0 2h1v20H1a1 1 0 1 0 0 2h22a1 1 0 1 0 0-2M4 2h16v20H4zm13.85 13.653A2.62 2.62 0 0 0 15.4 14h-2.399v-2h2a1 1 0 1 0 0-2h-2V8h4a1 1 0 1 0 0-2h-4V5a1 1 0 1 0-2 0v1h-4a1 1 0 1 0 0 2h4v2h-2a1 1 0 1 0 0 2h2v2h-2.44a2.61 2.61 0 0 0-2.43 1.645 2.61 2.61 0 0 0 .578 2.877l.6.6c.566.566 1.32.879 2.121.879h5.143c.801 0 1.555-.312 2.121-.879l.576-.576a2.62 2.62 0 0 0 .581-2.892zm-1.995 1.478-.576.576a1 1 0 0 1-.707.293H9.429c-.263 0-.521-.106-.707-.293l-.6-.6a.63.63 0 0 1-.142-.705A.64.64 0 0 1 8.6 16h6.791a.64.64 0 0 1 .607.411.64.64 0 0 1-.145.72z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-x-ray_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrXRay;
